import Icon from '../components/Icon.vue'

Icon.register({
  monument: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M368 448c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-352c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h352zM289.1 100.7l30.9 315.3h-256l30.9-315.3c0.6-6.3 4.8-15 9.2-19.4l76.6-76.6c6.3-6.3 16.4-6.3 22.6 0l76.6 76.6c4.5 4.5 8.6 13.2 9.2 19.4zM240 307.2v-38.4c0-6.4-6.4-12.8-12.8-12.8h-70.4c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8h70.4c6.4 0 12.8-6.4 12.8-12.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/monument.js
// module id = 1581
// module chunks = 0